function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import { pushToDataLayer } from '@domain-group/fe-helper';
import Modal from '@domain-group/fe-co-modal';
import AllhomesEnquiryForm from '../../allhomes-enquiry-form';
import { appearancePropTypes } from '../../utils/appearance';
import * as styles from './agent-enquiry-form.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var optionsAgency = [{
  id: 'SELLING',
  value: 'SELLING_PROPERTY',
  label: "I'm selling a property"
}, {
  id: 'BUYING',
  value: 'BUYING_PROPERTY',
  label: "I'm looking to buy a property"
}, {
  id: 'RENTING',
  value: 'RENTING_PROPERTY',
  label: "I'm looking to rent a property"
}, {
  id: 'APPRAISAL',
  value: 'PROPERTY_APPRAISAL',
  label: "I'd like a property appraisal"
}, {
  id: 'LEASING',
  value: 'LEASING_PROPERTY',
  label: "I'm leasing a property"
}, {
  id: 'NONE',
  value: 'NONE_OF_ABOVE',
  label: 'None of above'
}];
var sendToDataLayer = param => {
  pushToDataLayer({
    event: 'GAevent',
    eventCategory: 'Conversion',
    eventAction: 'Email Enquiry - Find an Agent',
    eventLabel: 'Agent Banner',
    user: {
      emailHash: param
    }
  });
};
class AgentEnquiryForm extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleEnquirySent", param => {
      try {
        sendToDataLayer(param);
      } catch (error) {
        // don't let GA problems prevent event passing through.
      }
      this.props.submitFormCallback(param);
    });
  }
  render() {
    return ___EmotionJSX("div", {
      css: styles.container
    }, ___EmotionJSX(Modal, {
      closeCallback: this.props.closeCallback,
      animated: false,
      minimal: false
    }, ___EmotionJSX(AllhomesEnquiryForm, {
      endpointUrl: this.props.endpointUrl,
      logoUrl: this.props.logoUrl,
      formTitle: this.props.formTitle,
      appearance: this.props.appearance,
      doneText: "Close",
      onDoneClick: this.props.closeCallback,
      onEnquirySent: this.handleEnquirySent,
      enableMessage: true,
      messagePlaceholder: "Write your message",
      formData: {
        id: this.props.clientId,
        type: this.props.clientType
      },
      options: optionsAgency,
      agencies: this.props.agencies,
      agents: this.props.agents
    })));
  }
}
AgentEnquiryForm.propTypes = {
  appearance: appearancePropTypes,
  endpointUrl: PropTypes.string.isRequired,
  formTitle: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  clientId: PropTypes.number,
  clientType: PropTypes.string.isRequired,
  closeCallback: PropTypes.func,
  submitFormCallback: PropTypes.func,
  agencies: PropTypes.arrayOf({
    agency: PropTypes.shape({})
  }),
  agents: PropTypes.arrayOf({
    agent: PropTypes.shape({})
  })
};
AgentEnquiryForm.defaultProps = {
  appearance: 'agent',
  logoUrl: null,
  clientId: null,
  closeCallback: () => {},
  submitFormCallback: () => {},
  agencies: [],
  agents: []
};
export default AgentEnquiryForm;